export default __webpack_public_path__ + "static/char-s-20-en-0cafd3df77b496e1aa833edb860e9be7.png";